import './App.css';
import AppExchange from './comps/appExchange';

function App() {
  return (
    <div className="App">
      <AppExchange />
    </div>
  );
}

export default App;
